export default "__VITE_ASSET__241995bc__"